export default __webpack_public_path__ + "static/media/radio.ffda4dca.svg";